<div class="wrap">
  <alert *ngIf="error" [type]="'danger'" class="alert-top d-block mt-4">
    <div><i-feather name="alert-triangle" class="mr-2"></i-feather> {{ error }}</div>
  </alert>
  <div class="recorder form-row">
    <div class="toolbar col-auto mr-4">
      <a (click)="cancel()" class="position-relative mr-3">
        <i-feather name="x" class="icon-lg pointer"></i-feather>
      </a>
      <button class="js-record btn btn-ico rounded-circle btn-danger">
        <i-feather *ngIf="!isRecording" name="mic" class="icon-lg"></i-feather>
        <i-feather *ngIf="isRecording" name="square" class="icon-lg"></i-feather>
      </button>
      <audio class="js-audio audio audio--hidden" controls></audio>
    </div>
    <div class="waveform no-invert col">
      <button [class.hidden]="isRecording" class="js-play btn btn-ico button--play rounded-circle hidden">
        <i-feather *ngIf="!isPlaying" name="play" class="no-invert"></i-feather>
        <i-feather *ngIf="isPlaying" name="pause" class="no-invert"></i-feather>
      </button>
      <canvas [class.pl-8]="!isRecording" class="js-canvas waveform__canvas"></canvas>
    </div>
    <div class="toolbar col-auto mr-4">
      <button
        [disabled]="isSending"
        [class.btn-circle-load]="isSending"
        (click)="sendVoice()"
        class="js-send btn btn-ico btn-primary rounded-circle"
        type="button"
      >
        <i-feather name="send" class="icon-md"></i-feather>
      </button>
    </div>
  </div>
</div>
